module.exports = __webpack_public_path__ + "img/1-sm.38981923.jpg";